import React from "react";
//import { useStaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";
import Box from "common/components/Box";
import Text from "common/components/Text";
import Heading from "common/components/Heading";
import Container from "common/components/UI/Container";
import SectionWrapper from "./service.style";
import locImg from "../../images/location.svg";
import tourLen from "../../images/tourLen.svg";
import tourDur from "../../images/tourDur.svg";
import tourPrice from "../../images/wallet.svg";
import hourImg from "../../images/hours.svg";
import Button from "common/components/Button";

const ServiceSection = ({
  secTitleWrapper,
  secText,
  secHeading,
  Row,
  Col,

  serviceTitleStyle,
  locTour,
  distTour,
  priceTour,
  durTour,
  hoursRange,
  lang = "He",
}) => {
  /* const Data = useStaticQuery(graphql`
    query {
      saasClassicJson {
        SERVICE_ITEMS {
          title
          icon
        }
      }
    }
  `); */
  const textStyle = {
    fontWeight: "700",
  };
  const formatLabel = (secs) => {
    if (secs === 86400) secs = 86360;
    var minutes = Math.floor(secs / 60);
    var hours = Math.floor(minutes / 60);
    minutes = minutes % 60;
    return `${hours}:${("0" + minutes).slice(-2)}`;
  };

  const textLang = {
    topTitle: {
      He: "רוצים לדעת אם הסיור מתאים לכם?",
      En: "Wondering if it's your tour? ",
    },
    mainTitle: {
      He: "הנה כמה פרטים שיעזרו לכם להבין",
      En: "Some details that helps you know",
    },
    location: {
      He: "המיקום",
      En: "The Location",
    },
    tourLen: {
      He: "אורך המסלול",
      En: "The Length",
    },
    lenLeter: {
      He: "ק'",
      En: "K",
    },
    price: {
      He: "המחיר",
      En: "The Price",
    },
    tourDur: {
      He: "משך",
      En: "The Duration",
    },
    tourTime: {
      He: "השעות",
      En: "When Duable",
    },
    hourWord: {
      He: "שעות",
      En: "Hours",
    },
  };
  return (
    <SectionWrapper style={{ direction: lang === "He" ? "rtl" : "ltr" }}>
      <Container>
        <Box {...secTitleWrapper}>
          <Text {...secText} content={textLang["topTitle"][lang]} />
          <Heading {...secHeading} content={textLang["mainTitle"][lang]} />
          {/*  <Text
            {...secDes}
            content="The rise of mobile devices transforms the way we consume information entirely and the world's most relevant channels such as Facebook and Instagram are almost exclusively used on mobile that is why we developed mobile."
          />*/}
        </Box>

        <Box {...Row}>
          <Box {...Col} key={`service-item-${1}`}>
            <Box className="service_item">
              <Box className="service_icon">
                <img style={{ width: "110px" }} src={locImg} alt="Location" />
              </Box>
              <Heading
                as="h3"
                content={textLang["location"][lang]}
                {...serviceTitleStyle}
              />
              <Text {...textStyle} content={locTour} />
            </Box>
          </Box>
          <Box {...Col} key={`service-item-${2}`}>
            <Box className="service_item">
              <Box className="service_icon">
                <img style={{ width: "110px" }} src={tourLen} alt="Location" />
              </Box>
              <Heading
                as="h3"
                content={textLang["tourLen"][lang]}
                {...serviceTitleStyle}
              />
              <Text
                {...textStyle}
                content={`${(distTour / 1 / 1000).toFixed(2)} ${
                  textLang["lenLeter"][lang]
                }`}
              />
            </Box>
          </Box>
          <Box {...Col} key={`service-item-${2}`}>
            <Box className="service_item">
              <Box className="service_icon">
                <img
                  style={{ width: "110px", height: "72px" }}
                  src={tourPrice}
                  alt="price"
                />
              </Box>
              <Heading
                as="h3"
                content={textLang["price"][lang]}
                {...serviceTitleStyle}
              />
              <Text {...textStyle} content={`${priceTour} \u20AA`} />
            </Box>
          </Box>
          <Box {...Col} key={`service-item-${3}`}>
            <Box className="service_item">
              <Box className="service_icon">
                <img style={{ width: "110px" }} src={tourDur} alt="Location" />
              </Box>
              <Heading
                as="h3"
                content={textLang["tourDur"][lang]}
                {...serviceTitleStyle}
              />
              <Text
                {...textStyle}
                content={`${durTour} ${textLang["hourWord"][lang]}`}
              />
            </Box>
          </Box>
          <Box {...Col} key={`service-item-${4}`}>
            <Box className="service_item">
              <Box className="service_icon">
                <img style={{ width: "110px" }} src={hourImg} alt="Location" />
              </Box>
              <Heading
                as="h3"
                content={textLang["tourTime"][lang]}
                {...serviceTitleStyle}
              />
              {hoursRange && (
                <Text
                  {...textStyle}
                  content={`${formatLabel(hoursRange.min)} - ${formatLabel(
                    hoursRange.max
                  )}`}
                />
              )}
            </Box>
          </Box>
        </Box>
      </Container>
    </SectionWrapper>
  );
};

ServiceSection.propTypes = {
  secTitleWrapper: PropTypes.object,
  secText: PropTypes.object,
  secHeading: PropTypes.object,
  Row: PropTypes.object,
  Col: PropTypes.object,
  serviceTitleStyle: PropTypes.object,
  secDes: PropTypes.object,
};

ServiceSection.defaultProps = {
  secTitleWrapper: {
    mb: ["60px", "80px"],
  },
  secText: {
    as: "span",
    display: "block",
    textAlign: "center",
    fontSize: "16px",
    letterSpacing: "0.15em",
    fontWeight: "700",
    color: "#E14A1B", // "#ff4362",
    mb: "12px",
  },
  secHeading: {
    textAlign: "center",
    fontSize: ["20px", "24px", "36px", "36px"],
    fontWeight: "700",
    color: "#0f2137",
    letterSpacing: "-0.025em",
    mb: "0",
    ml: "auto",
    mr: "auto",
    lineHeight: "1.12",
    width: "540px",
    maxWidth: "100%",
  },
  Row: {
    flexBox: true,
    flexWrap: "wrap",
    justifyContent: "center",
    ml: ["0", "-15px", "-20px", "-35px", "-35px"],
    mr: ["0", "-15px", "-20px", "-35px", "-35px"],
  },
  Col: {
    pl: ["15px", "15px", "25x", "35px", "35px"],
    pr: ["15px", "15px", "25px", "35px", "35px"],
    mb: "40px",
  },
  serviceTitleStyle: {
    fontSize: ["15px", "15px", "15px", "16px", "17px"],
    fontWeight: "500",
    color: "#E14A1B", //"#ff4361",
    mb: 0,
  },
  secDes: {
    fontSize: ["14px", "15px", "16px"],
    color: "#5d646d",
    lineHeight: "1.875",
    mt: "30px",
    ml: "auto",
    mr: "auto",
    width: "470px",
    maxWidth: "100%",
    textAlign: "center",
  },
};

export default ServiceSection;
